module.exports = __webpack_public_path__ + "img/other3.96f204d7.png";